@if (pendingAppointments().length > 0) {
  <div class="approve-container">
    <div class="title">{{ 'confirm_appointment.title' | translate }}</div>
    @for (item of pendingAppointments(); track item.id) {
      <div class="pending-row">
        <div class="info">
          <span class="date"><mat-icon>calendar_today</mat-icon> {{ item.date | date:'dd/M/yyyy' }}</span>
          <span class="time"><mat-icon>watch_later</mat-icon> {{ getAppointmentLocalStartEndTime(item) }}</span>
        </div>
        <div class="actions">
          @if (loading()) {
            <span class="loader"></span>
          } @else {
            <mat-icon matRipple class="reject" (click)="reject(item)">thumb_down</mat-icon>
            <mat-icon matRipple class="accept" (click)="accept(item)">thumb_up</mat-icon>
          }
        </div>      
      </div>
    }
  </div>
}

